import classes from "../Style/Sidebar.scss";
import { Box } from "@mui/material";
import Logo from "../Components/Logo";
import Menu from "../Components/Menu";
import ImportantConceptsMenu from "../Components/ImportantConceptsMenu";
import FeedbackButton from "../Components/FeedbackButton";
import ShareButtons from "../Components/ShareButtons";

const Sidebar = (props) => {
    return (
        <Box className="sidebar" sx={{ position: 'sticky', top: 0 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between' }}>
                <Logo />
                {!props.isRoot && <Menu path={props.path} />}
                <Box sx={{ marginBottom: '2rem' }}>
                    {!props.isRoot && <FeedbackButton />}
                    {!props.isRoot && <ImportantConceptsMenu />}
                    {!props.isRoot && <ShareButtons />}
                </Box>

            </Box>
        </Box>
    );

}

export default Sidebar;